/**
 * 获取当前语言环境信息
 * https://km.sankuai.com/collabpage/1559627513
 */
const getLocaleLanguage = () => {
  const SLMPI18N = Mach.requireModule('Intl')
  const { locale = 'en' } = SLMPI18N.getCurrentLocaleInfo() || {}
  return locale
}

export { getLocaleLanguage }
